import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tooltip } from "primereact/tooltip";
import React, { useEffect, useRef, useState } from "react";
import Margin from "../Margin";
import { useFetchGet } from "Services/api";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Loader from "Components/Loader/loader";

/**
 * Composant 'CompaniesCountBySectorTable'
 *
 * Tableau des entreprises par secteur
 *
 * @param {Object} props - Les props du composant
 * @param {Object} props.auth - Reducer contenant les informations d'authentification
 * @param {string} props.auth.token - Le token de l'utilisateur connecté
 * @returns
 */
const CompaniesCountBySectorTable = (props) => {
  const apiRequest = useFetchGet(
    "/companies/stats/count/sectors",
    props.auth.token
  );

  const [companiesBySector, setCompaniesBySector] = useState(undefined);

  useEffect(() => {
    try {
      if (apiRequest.loaded) {
        setCompaniesBySector(
          apiRequest.data["hydra:member"] || apiRequest.data
        );
      }
    } catch (_) {
      setCompaniesBySector([]);
    }
  }, [apiRequest.loaded]);
  const dt = useRef(null);

  const cols = [
    { field: "sector", header: "Nom du secteur" },
    { field: "count", header: "Nombre d'entreprises" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportCSV = () => {
    dt.current.exportCSV(companiesBySector);
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, companiesBySector);
        doc.save("entreprises_par_secteur.pdf");
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const newData = companiesBySector.map((row) => {
        return [row.sector, row.count];
      });
      const workBook = xlsx.utils.book_new();
      const workSheetData = [cols.map((col) => col.header), ...newData];
      const workSheet = xlsx.utils.aoa_to_sheet(workSheetData);
      xlsx.utils.book_append_sheet(
        workBook,
        workSheet,
        "Entreprises par secteur"
      );
      xlsx.writeFile(workBook, "entreprises_par_secteur.xlsx");
    });
  };

  const header = (
    <div className="flex align-items-center export-buttons stats_container__table-tooltip">
      <Button
        type="button"
        icon="pi pi-file"
        onClick={() => exportCSV(false)}
        className="mr-2 csv"
        data-pr-tooltip="CSV"
      />
      <Button
        type="button"
        icon="pi pi-file-excel"
        onClick={exportExcel}
        className="p-button-success mr-2 xl"
        data-pr-tooltip="XLS"
      />
      <Button
        type="button"
        icon="pi pi-file-pdf"
        onClick={exportPdf}
        className="p-button-warning mr-2 pdf"
        data-pr-tooltip="PDF"
      />
    </div>
  );

  return (
    <div>
      <div className="stats_container__table">
        <h5 className="stats_container__table-title">
          Nombre d&apos;entreprises par secteur
        </h5>
        <Margin position="bottom" size="xxs" />
        {companiesBySector ? (
          <React.Fragment>
            <Tooltip target=".export-buttons>button" position="bottom" />
            <DataTable
              id="offers-table"
              value={companiesBySector}
              responsiveLayout="scroll"
              dataKey="id"
              header={header}
              scrollable
              scrollHeight="500px"
              ref={dt}
              sortField="companiesNumber"
              sortOrder={-1}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entreprises"
            >
              {cols.map((col, index) => (
                <Column
                  key={index}
                  field={col.field}
                  header={col.header}
                  sortable
                />
              ))}
            </DataTable>
          </React.Fragment>
        ) : (
          <div
            style={{
              height: "500px",
            }}
          >
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

CompaniesCountBySectorTable.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompaniesCountBySectorTable);
